import { toast } from "react-toastify";
import { endpoints } from "../../../configs/Settings";
import { HTTPResponseStatus } from "../../../utils/enum";
import { useAuth } from "../../../utils/useAuth";
import { useAxios } from "../../../utils/useAxios";

/** Desativa a Organization (active = false). Não apaga o recurso. */
export async function PatchOrganizationActive(organizationId: string) {
  const url = `${endpoints.ADMFHIR}/Organization/${organizationId}`;
  const headers = {
    Accept: "*/*",
    Authorization: await useAuth.getUserToken(),
    "Content-Type": "application/json-patch+json",
  };
  const data = [{ op: "replace", path: "/active", value: false }];

  const response = await useAxios
    .patch(url, data, { headers, timeout: 8000 })
    .then((result) => {
      if (result.status !== HTTPResponseStatus.Success) {
        throw new Error(`PatchOrganizationActive: ${result.status}`);
      }
      return result.data;
    })
    .catch((error) => {
      console.error("PatchOrganizationActive ", error);
      throw new Error();
    });

  if (response) return response;
}
